import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { AsyncPipe, NgClass, UpperCasePipe } from '@angular/common';

import { StoreService, StoreView, TranslatePipe } from '@speedy/core';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-store-switcher',
  templateUrl: './store-switcher.component.html',
  styleUrls: ['./store-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconButton,
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    NgClass,
    UpperCasePipe,
    TranslatePipe,
    AsyncPipe,
  ],
})
export class StoreSwitcherComponent implements OnInit {
  private storeService = inject(StoreService);
  private router = inject(Router);

  @Output() childEvent = new EventEmitter();

  currentStore = this.storeService.getCurrentStore();
  stores: StoreView[] = Object.values(this.storeService.getStores());

  ngOnInit() {
    this.storeService.store$.subscribe((store) => {
      this.currentStore = store;
    });
  }

  /**
   * will change the url, which in place will change store code
   * @param store
   */
  setCurrentStore(store: StoreView) {
    const url = this.router.routerState.snapshot.url;
    const urlParts = url.split('/');
    urlParts[1] = store.code;
    const newUrl = '/' + urlParts.join('/');
    this.router.navigate([newUrl]);
    this.toggleMenu();
  }

  toggleMenu() {
    this.childEvent.emit();
  }
}
